import React from 'react'
import SubAdminSideBar from './SubAdminSideBar'
import SubAdminHeader from './SubAdminHeader'

const SubAdminMain = (props) => {
  return (
    <div>
        <div className="row">
            <div className="col-md-3">
                <SubAdminSideBar/>
            </div>
            <div className="col-md-9">
             <div> <SubAdminHeader/></div>
             <div
  style={{
    maxHeight: "500px", 
    overflowY: "auto",
    border: "1px solid #ccc", 
    padding: "0px",
  }}
>
  {props.subadmin}
</div>

            </div>
        </div>
    </div>
  )
}

export default SubAdminMain
